import { getTempToken } from "./authService";


export const getAllComments = async () => {
  const token = await getTempToken();
  // const token = localStorage.getItem('token');
  if (!token) return null;

  const endpoint = 'https://tsoministries.com/wp-json/wp/v2/comments';
  const perPage = 100;
  let page = 1;
  let allComments = [];

  try {
    while (true) {
      const response = await fetch(`${endpoint}?per_page=${perPage}&page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 400 && page > 1) {
          // WordPress returns 400 when page is out of range
          break;
        }
        throw new Error('Failed to fetch comments');
      }

      const comments = await response.json();
      allComments = allComments.concat(comments);

      // If fewer than perPage, no more pages
      if (comments.length < perPage) break;

      page++;
    }

    return allComments;
  } catch (error) {
    console.error('Error fetching comments:', error);
    return null;
  }
};

export const postComment = async (testimonial, user) => {
  try {
    // fetch ministry page id
    const response = await fetch(
      `https://tsoministries.com/wp-json/wp/v2/pages?slug=${testimonial.ministry.url.replace("/", "")}`
    );
    const data = await response.json();
    if (!data.length) throw new Error("Page not found");
    const pageId = data[0].id;

    const token = await getTempToken();
    const res = await fetch("https://tsoministries.com/wp-json/wp/v2/comments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        post: pageId,
        content: testimonial.content,
        author: user.id,
        meta: {
          testimonial_title: testimonial.title,
        },
      }),
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      console.error("WP API Error:", errorData);
      throw new Error(errorData.message || "Failed to post comment");
    }

    return { success: true };
  } catch (error) {
    console.error("Error posting testimony:", error);
    return { success: false, message: error.message || "Unexpected error" };
  }
};

export const fetchTHPRegistrants = async () => {
  return fetchPortalRegistrants('thp');
};

export const fetchBBBRegistrants = async () => {
  return fetchPortalRegistrants('bbb');
};

export const fetchVTCRegistrants = async () => {
  return fetchPortalRegistrants('vtc');
};

export const fetchPopMyCherryRegistrants = async () => {
  return fetchPortalRegistrants('pop_my_cherry');
};

const fetchPortalRegistrants = async (slug) => {
  const endpoint = `https://tsoministries.com/wp-json/wp/v2/${slug}`;
  let page = 1;
  let allRegistrants = [];

  try {
    while (true) {
      const response = await fetch(
        `${endpoint}?per_page=100&page=${page}`
      );

      if (!response.ok) {
        if (response.status === 400 && page > 1) break;
        throw new Error(`Error fetching page ${page} for ${slug}`);
      }

      const data = await response.json();

      if (!Array.isArray(data) || data.length === 0) break;

      allRegistrants = [...allRegistrants, ...data];
      if (data.length < 100) break;

      page++;
    }

    return allRegistrants;
  } catch (error) {
    console.error(`Failed to fetch ${slug} registrants:`, error);
    return [];
  }
};


export const getAllPages = async () => {
  const allPages = []
  let page = 1
  const perPage = 100

  while (true) {
    const res = await fetch(`https://tsoministries.com/wp-json/wp/v2/pages?page=${page}&per_page=${perPage}`)

    if (!res.ok) break

    const data = await res.json()
    if (data.length === 0) break

    allPages.push(...data)
    page++
  }

  return allPages
}


// export const fetchLibraryItems = async () => {
//   const endpoint = 'https://tsoministries.com/wp-json/wp/v2/library';
//   let page = 1;
//   let allData = [];

//   try {
//     while (true) {
//       const response = await fetch(`${endpoint}?per_page=100&page=${page}`);

//       if (!response.ok) {
//         if (response.status === 400 && page > 1) break;
//         Toast(`Error fetching page ${page}`);
//       }

//       const data = await response.json();
//       if (!Array.isArray(data) || data.length === 0) break;
//       allData = [...allData, ...data];
//       if (data.length < 100) break; // No more full pages
//       page++;
//     }
//   } catch (error) {
//     Toast('Failed to fetch registrants:', error);
//   } finally {
//     return allData;
//   }
// };


export const fetchLibraryItems = async (onBatchLoaded) => {
  const endpoint = 'https://tsoministries.com/wp-json/wp/v2/library';
  let page = 1;
  let allData = [];

  try {
    while (true) {
      const response = await fetch(`${endpoint}?per_page=100&page=${page}`);

      if (!response.ok) {
        if (response.status === 400 && page > 1) break;
        console.error(`Error fetching page ${page}`);
        break;
      }

      const data = await response.json();
      if (!Array.isArray(data) || data.length === 0) break;

      allData = [...allData, ...data];

      // 🔄 Send current batch to caller
      if (onBatchLoaded) onBatchLoaded([...allData]);

      if (data.length < 100) break; // No more full pages
      page++;
    }
  } catch (error) {
    console.error('Failed to fetch library items:', error);
  }

  return allData;
};

export const fetchLibraryItemsWithTemp = async () => {
  const endpoint = 'https://tsoministries.com/wp-json/wp/v2/library';
  let page = 1;
  let tempItems = [];

  try {
    while (true) {
      const response = await fetch(`${endpoint}?per_page=100&page=${page}`);

      if (!response.ok) {
        if (response.status === 400 && page > 1) break;
        console.error(`Error fetching page ${page}`);
        break;
      }

      const data = await response.json();
      if (!Array.isArray(data) || data.length === 0) break;

      // 👇 Filter only those with type === 'bst'
      const filtered = data.filter(item => item.acf?.type === 'bst');
      tempItems = [...tempItems, ...filtered];

      page++;
      if (data.length < 100) break;
    }
  } catch (error) {
    console.error('Failed to fetch library items:', error);
  }

  return tempItems;
};






export const syncYouTubeLibrary = async ({
  API_KEY,
  channelId,
  includeSupplementary = false,
  supplementaryItems = [],
  onStatusUpdate,
}) => {
  try {
    onStatusUpdate("Fetching YouTube uploads...");

    const playlistRes = await fetch(
      `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${channelId}&key=${API_KEY}`
    );
    const playlistData = await playlistRes.json();
    const uploadsPlaylistId =
      playlistData.items[0]?.contentDetails?.relatedPlaylists?.uploads;

    if (!uploadsPlaylistId) throw new Error("No upload playlist found");

    let nextPageToken = null;
    const allVideos = [];

    while (true) {
      const listUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet,contentDetails&playlistId=${uploadsPlaylistId}&maxResults=50&pageToken=${nextPageToken || ""}&key=${API_KEY}`;
      const videoRes = await fetch(listUrl);
      const videoData = await videoRes.json();

      allVideos.push(...videoData.items);
      if (!videoData.nextPageToken) break;
      nextPageToken = videoData.nextPageToken;
    }

    onStatusUpdate(`Fetched ${allVideos.length} YouTube items.`);

    const formattedYouTubeItems = await Promise.all(
      allVideos.map(async (item) => {
        const videoId = item.contentDetails.videoId;
        const snippet = item.snippet;
        const title = snippet.title.toLowerCase();

        let duration = "";
        let views = 0;
        let likes = 0;
        let isLive = false;

        try {
          const videoDetailRes = await fetch(
            `https://www.googleapis.com/youtube/v3/videos?part=contentDetails,statistics,liveStreamingDetails&id=${videoId}&key=${API_KEY}`
          );
          const detailJson = await videoDetailRes.json();
          const videoDetails = detailJson.items[0];

          const isoDuration = videoDetails?.contentDetails?.duration || "";
          duration = isoDuration
            .replace("PT", "")
            .replace("H", "h ")
            .replace("M", "m ")
            .replace("S", "s")
            .trim();

          views = parseInt(videoDetails?.statistics?.viewCount || "0");
          likes = parseInt(videoDetails?.statistics?.likeCount || "0");

          isLive = !!videoDetails?.liveStreamingDetails;
        } catch (err) {
          console.warn(`Could not fetch details for video ${videoId}`, err);
        }

        // Detect format
        const isAudio =
          title.includes("podcast") || title.includes("audio");
        const format = isAudio ? "audio" : "video";

        // Determine library_type
        let library_type = format; // default to format (video or audio)
        if (isLive) {
          if (
            title.includes("bible study with") ||
            title.includes("how to read the bible")
          ) {
            library_type = "bst";
          } else if (
            title.includes("the healing party") ||
            title.includes("life in the spirit")
          ) {
            library_type = "event";
          } else {
            library_type = "live";
          }
        }

        return {
          youtube_id: videoId,
          youtube_url: `https://youtube.com/watch?v=${videoId}`,
          thumbnail: snippet.thumbnails.high.url,
          date: snippet.publishedAt,
          duration,
          speaker: "",
          study_notes: { visible: false, content: "", signed: false },
          title: snippet.title,
          description: snippet.description,
          library_type,
          format,
          views,
          likes,
          deleted: "false",
          visible: "true",
          isManualUpdate: false,
        };
      })
    );

    const finalItems = includeSupplementary
      ? [...formattedYouTubeItems, ...supplementaryItems]
      : formattedYouTubeItems;

    // onStatusUpdate("Clearing existing library...");
    // const existingItems = await fetchLibraryItems();
    // const idsToDelete = existingItems.map((item) => item.id);

    // const deleteRes = await fetch(
    //   `https://tsoministries.com/wp-json/custom-form/v1/library-bulk-delete`,
    //   {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify(idsToDelete),
    //   }
    // );
    // const result = await deleteRes.json();
    // onStatusUpdate(`Deleted ${result.deleted}/${idsToDelete.length} items.`);

    onStatusUpdate("Uploading new items...");
    let uploadCount = 0;
    for (const item of finalItems) {
      await fetch("https://tsoministries.com/wp-json/custom-form/v1/library", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(item),
      });
      uploadCount++;
      onStatusUpdate(`Uploaded ${uploadCount}/${finalItems.length}`);
    }

    onStatusUpdate("Sync complete.");
    return { total: finalItems.length };
  } catch (error) {
    onStatusUpdate("Sync failed.");
    console.error("Error syncing YouTube to Library:", error);
    throw error;
  }
};

export const updateLibraryItem = async (item) => {
  try {
    const response = await fetch("https://tsoministries.com/wp-json/custom-form/v1/library-update", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      throw new Error("Update failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error updating library item:", error);
    throw error;
  }
};






// ✅ Fetch daily declarations (loop paginated like others)
export const fetchDailyDeclarations = async () => {
  const endpoint = `https://tsoministries.com/wp-json/custom/v1/get-daily-declarations/`;
  let page = 1;
  let allDeclarations = [];

  try {
    while (true) {
      const response = await fetch(`${endpoint}?per_page=100&page=${page}`);

      if (!response.ok) {
        if (response.status === 400 && page > 1) break;
        throw new Error(`Error fetching page ${page} for daily declarations`);
      }

      const data = await response.json();
      if (!Array.isArray(data) || data.length === 0) break;

      allDeclarations = [...allDeclarations, ...data];
      if (data.length < 100) break;

      page++;
    }

    return allDeclarations;
  } catch (error) {
    console.error("Failed to fetch daily declarations:", error);
    return [];
  }
};

// ✅ Create or update a declaration
export const submitDailyDeclaration = async (declaration) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/submit-daily-declaration/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(declaration),
      }
    );

    if (!response.ok) {
      throw new Error("Submit failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error submitting declaration:", error);
    throw error;
  }
};

// ✅ Delete a declaration by ID
export const deleteDailyDeclaration = async (id) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/delete-daily-declaration/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      }
    );

    if (!response.ok) {
      throw new Error("Delete failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error deleting declaration:", error);
    throw error;
  }
};



// ✅ Fetch bio data (loop paginated like others)
export const fetchBioData = async () => {
  const endpoint = `https://tsoministries.com/wp-json/custom/v1/get-bdfs/`;

  try {
    const response = await fetch(endpoint);

    if (!response.ok) {
      throw new Error(`Error fetching bio data forms: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to fetch bio data form:", error);
    return [];
  }
};

// ✅ Create or update a bio data
export const submitBioData = async (declaration) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/submit-bdf/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(declaration),
      }
    );

    if (!response.ok) {
      throw new Error("Submit failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error submitting bio data:", error);
    throw error;
  }
};

// ✅ Delete a bio data by ID
export const deleteBioData = async (id) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/delete-bdf/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      }
    );

    if (!response.ok) {
      throw new Error("Delete failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error deleting bio data:", error);
    throw error;
  }
};




///// PATNER ENDPOINT
// ✅ Fetch Partners (loop paginated like others)
export const fetchPartners = async () => {
  const endpoint = `https://tsoministries.com/wp-json/custom/v1/get-partners/`;

  try {
    const response = await fetch(endpoint);

    if (!response.ok) {
      throw new Error(`Error fetching bio data forms: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to fetch bio data form:", error);
    return [];
  }
};

// ✅ Create or update a partner form
export const submitPartnerForm = async (partnerForm) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/submit-partner-form/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(partnerForm),
      }
    );

    if (!response.ok) {
      throw new Error("Submit failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error submitting partner form:", error);
    throw error;
  }
};

// ✅ Delete a partner form by ID
export const deletePartnerForm = async (id) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/delete-partner-form/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      }
    );

    if (!response.ok) {
      throw new Error("Delete failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error deleting partner form:", error);
    throw error;
  }
};



///// VOLUNTEER ENDPOINT
// ✅ Fetch Volunteers(loop paginated like others)
export const fetchVolunteers = async () => {
  const endpoint = `https://tsoministries.com/wp-json/custom/v1/get-volunteers/`;

  try {
    const response = await fetch(endpoint);

    if (!response.ok) {
      throw new Error(`Error fetching bio data forms: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to fetch bio data form:", error);
    return [];
  }
};

// ✅ Create or update a Volunteers form
export const submitVolunteerForm = async (partnerForm) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/submit-partner-form/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(partnerForm),
      }
    );

    if (!response.ok) {
      throw new Error("Submit failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error submitting partner form:", error);
    throw error;
  }
};

// ✅ Delete a Volunteers form by ID
export const deleteVolunteerForm = async (id) => {
  try {
    const response = await fetch(
      "https://tsoministries.com/wp-json/custom/v1/delete-partner-form/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      }
    );

    if (!response.ok) {
      throw new Error("Delete failed");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error deleting partner form:", error);
    throw error;
  }
};



export const fetchBSTM = async () => {
  const endpoint = `https://tsoministries.com/wp-json/custom/v1/get-bstm/`;

  try {
    const response = await fetch(endpoint);

    if (!response.ok) {
      throw new Error(`Error fetching bio data forms: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to fetch bio data form:", error);
    return [];
  }
};













// //Weekly - Game Actions

export async function updateWeeklyLevel(payload) {
  const res = await fetch(`https://tsoministries.com/wp-json/custom/v1/weekly-levels/${payload.id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error("Failed to update level")
  return res.json()
}

export async function deleteWeeklyLevel(id) {
  const res = await fetch(`https://tsoministries.com/wp-json/custom/v1/weekly-levels/${id}`, { method: "DELETE" })
  if (!res.ok) throw new Error("Failed to delete level")
  return true
}


// Weekly - Game Actions (Fixed)
export async function getWeeklyLevels() {
  const endpoint = `https://tsoministries.com/wp-json/weekly-game/v1/levels`;
  try {
    const response = await fetch(endpoint);

    if (!response.ok) {
      throw new Error(`Error fetching Weekly Game Levels: ${response.status}`);
    }

    const data = await response.json();

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to fetch bio data form:", error);
    return [];
  }
}

export async function createWeeklyLevel(payload) {
  const token = await getTempToken();
  if (!token) return null;
  const url = "https://tsoministries.com/wp-json/weekly-game/v1/level";

  console.log("[createWeeklyLevel] Sending payload:", payload);

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    console.log("[createWeeklyLevel] Status:", res.status, res.statusText);

    const text = await res.text();
    console.log("[createWeeklyLevel] Raw response:", text);

    let data;
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }

    if (!res.ok) {
      console.error("[createWeeklyLevel] Request failed:", {
        status: res.status,
        statusText: res.statusText,
        response: data,
      });
      return null;
    }

    console.log("[createWeeklyLevel] Success:", data);
    return data;

  } catch (err) {
    console.error("[createWeeklyLevel] Network or runtime error:", err);
    return null;
  }
}

// optional future endpoints
export async function submitWeeklyScore(payload) {
  const res = await fetch("https://tsoministries.com/wp-json/weekly-game/v1/submit-score", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error("Failed to submit score")
  return res.json()
}




// Convert ISO8601 duration format (PT1H2M3S) to readable format
export const parseISO8601Duration = (duration) => {
  const match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  const hours = match[1] ? match[1].replace("H", "") : "0";
  const minutes = match[2] ? match[2].replace("M", "") : "0";
  const seconds = match[3] ? match[3].replace("S", "") : "0";

  return `${hours !== "0" ? `${hours}:` : ""}${minutes}:${seconds.padStart(2, "0")}`;
};









